const BASE_URL = (import.meta.env.VITE_SITE_URL as string) || "https://flightfare.pk";

interface SeoMetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

export default function SeoMeta({
  title,
  description,
  keywords,
  canonical = "/",
  ogImage,
  ogType = "website",
  jsonLd,
}: SeoMetaProps) {
  const canonicalUrl = canonical.startsWith("http")
    ? canonical
    : `${BASE_URL}${canonical}`;

  const defaultOgImage =
    "https://public.readdy.ai/ai/img_res/c8b2b0c6e1b3c4fb85c69be3c1a99eba.jpg";

  const resolvedOgImage = ogImage || defaultOgImage;
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />
      <meta name="Last-Modified" content="2026-03-26" />
      {/* Open Graph */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={resolvedOgImage} />
      <meta property="og:site_name" content="flightfare.pk" />
      <meta property="og:locale" content="en_PK" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={resolvedOgImage} />
      {/* JSON-LD */}
      {schemas.map((schema, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}
